module.exports = __webpack_public_path__ + "img/image (164).b9ca3d75.jpg";